import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";

import DOMPurify from "dompurify";
import Parser from 'html-react-parser';
import DocumentView from "../../common/DocumentView";
import { ThreeDots } from "react-loader-spinner";

import Menu from "../../helpers/Menu";
import { Button } from "../../helpers";
import downloadFile from "../../utils/DownloadFile";

import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { useDispatch } from "react-redux";
import { getDocCopyByDocNo } from "../../services/api/docCopy";
import { getProformaInvoiceByProformaInvoiceId, getProformaInvoiceDocument } from "../../services/api/proformaInvoice";

import "./index.css"

const ProformaInvoice = () =>{
    const { proformaInvoiceId } = useParams()

    const [isLoading, setIsLoading] = useState(false)
    const [isPDFLoading, setIsPDFLoading] = useState(false)

    const actionMenu = useRef(null)

    const [proformaInvoice, setProforamInvoice] = useState({})
    const [proformaInvoiceDocumentHTML, setProformaInvoiceDocumentHTML] = useState('')
    const [proformaInvoicePdfUrl, setProformaInvoicePdfUrl] = useState('')

    const dispatch = useDispatch()


    useEffect(() => {
        getProformaInvoice()
    }, [proformaInvoiceId])

    const getProformaInvoice = async () => {  
        setIsLoading(true)

        const proformaInvoiceRes = await getProformaInvoiceByProformaInvoiceId(proformaInvoiceId)
        if (proformaInvoiceRes.failure){
            dispatch(raiseToast({severity:'error', summary: proformaInvoiceRes.data.error, detail:'Proforma Invoice Not Fetched', life: 3000}))
        }

        const profromaInvoiceDocumentRes = await getProformaInvoiceDocument(proformaInvoiceId)
        if (profromaInvoiceDocumentRes.failure){
            dispatch(raiseToast({severity:'error', summary: profromaInvoiceDocumentRes.data.error, detail:'HTML Document Not Fetched', life: 3000}))
        }

        setProforamInvoice(proformaInvoiceRes.data)
        
        if(profromaInvoiceDocumentRes.data.docCopy){
            setProformaInvoicePdfUrl(profromaInvoiceDocumentRes.data.docCopy.docLocation)
        } else {
            setProformaInvoiceDocumentHTML(profromaInvoiceDocumentRes.data.documentHTML)
        }
        setIsLoading(false)
    }

    const actionMenuItems = [
        {
            label: isPDFLoading ? "Loading..."  : 'Download Proforma Invoice',
            command: () => {
                if(proformaInvoicePdfUrl){
                    downloadFile(proformaInvoicePdfUrl, `proformaInvoice-${proformaInvoice?.docNo}.pdf`)
                }
                else{
                    setIsPDFLoading(true)
                    getProformaInvoicePDFURL()
                }
            },
            disabled: isPDFLoading || isLoading
        }
    ]

    const getProformaInvoicePDFURL = async () => {
        setIsPDFLoading(true)

        const docCopyRes = await getDocCopyByDocNo(proformaInvoice.docNo, true)

        if(docCopyRes.failure){
            setIsPDFLoading(false)
            return dispatch(raiseToast({severity:'error', summary: "Proforma Invoice Document", detail:docCopyRes.data.error, life: 3000}))
        }
        
        if(!docCopyRes.docLocation){
            setIsPDFLoading(false)
            return dispatch(raiseToast({severity:'error', summary: "Proforma Invoice Document", detail: "Proforma Invoice document was not found.", life: 3000}))
        }

        downloadFile(docCopyRes.docLocation, `proformaInvoice-${proformaInvoice?.docNo}.pdf`)
        setIsPDFLoading(false)

        getProformaInvoice()
    }

    const handleMenuToggle = (e) => {
        actionMenu.current.toggle(e)
    }

    const renderHTMLBuyerPODocument = (documentHTML) => {
        const sanitizedHTML = DOMPurify.sanitize(documentHTML)
        return(
            <>
                {Parser(sanitizedHTML)}
            </>
        )
    }

    const renderBuyerPOPDF = (proformaInvoicePdfUrl) => {
        return(
            <DocumentView fileUrl={proformaInvoicePdfUrl}/>
        )
    }

    return(
        <>
            <div style={{ }} className="buyer-po-doc pb-3 document-page">
                <div className="mb-0 document-page-container" style={{ width: "" }}>
                    <div className="flex flex-column md:flex-row md:justify-content-between">
                        <h4 className="mt-2 mb-0">PROFORMA INVOICE</h4> 
                        <div className="flex justify-content-end mb-2">
                            <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                            <Button className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Action" onClick={handleMenuToggle} />
                        </div>
                    </div>
                </div>
                {isLoading ? (
                    <div className="flex justify-content-center align-items-center">
                        <ThreeDots height="50" width="50" radius="5" color="#00baac" ariaLabel="three-dots-loading" visible={true} />
                    </div>
                    ) : (
                        proformaInvoicePdfUrl ? 
                            <div className="" style={{width: '210mm'}}>
                                {renderBuyerPOPDF(proformaInvoicePdfUrl)}
                            </div>
                        : 
                            <div className="">
                                {renderHTMLBuyerPODocument(proformaInvoiceDocumentHTML)}
                            </div>
                )}
            </div>
        </>
    )
}

export default ProformaInvoice